/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DateTimeRestrictionValidationData,
    DateTimeRestrictionValidationDataFromJSON,
    DateTimeRestrictionValidationDataFromJSONTyped,
    DateTimeRestrictionValidationDataToJSON,
    ListItemValidationMessage,
    ListItemValidationMessageFromJSON,
    ListItemValidationMessageFromJSONTyped,
    ListItemValidationMessageToJSON,
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarkupV2ValidationData
 */
export interface MarkupV2ValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof MarkupV2ValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof MarkupV2ValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof MarkupV2ValidationData
     */
    dateTimeRestrictionsTimeZone?: ValidationMessage;
    /**
     * 
     * @type {Array<DateTimeRestrictionValidationData>}
     * @memberof MarkupV2ValidationData
     */
    readonly dateTimeRestrictions?: Array<DateTimeRestrictionValidationData> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof MarkupV2ValidationData
     */
    readonly travelDates?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof MarkupV2ValidationData
     */
    readonly routes?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof MarkupV2ValidationData
     */
    readonly accountCodes?: Array<ListItemValidationMessage> | null;
    /**
     * 
     * @type {Array<ListItemValidationMessage>}
     * @memberof MarkupV2ValidationData
     */
    readonly bookingClasses?: Array<ListItemValidationMessage> | null;
}

export function MarkupV2ValidationDataFromJSON(json: any): MarkupV2ValidationData {
    return MarkupV2ValidationDataFromJSONTyped(json, false);
}

export function MarkupV2ValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupV2ValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : ValidationMessageFromJSON(json['dateTimeRestrictionsTimeZone']),
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionValidationDataFromJSON)),
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'accountCodes': !exists(json, 'accountCodes') ? undefined : (json['accountCodes'] === null ? null : (json['accountCodes'] as Array<any>).map(ListItemValidationMessageFromJSON)),
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : (json['bookingClasses'] === null ? null : (json['bookingClasses'] as Array<any>).map(ListItemValidationMessageFromJSON)),
    };
}

export function MarkupV2ValidationDataToJSON(value?: MarkupV2ValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'description': ValidationMessageToJSON(value.description),
        'dateTimeRestrictionsTimeZone': ValidationMessageToJSON(value.dateTimeRestrictionsTimeZone),
    };
}


